import { userAccepptedCookies } from './tracking-cookie'

export let rudder: Awaited<ReturnType<typeof getSdk>> | undefined

initRudderSdk()

export async function initRudderSdk() {
  if (
    typeof window === 'undefined' ||
    !userAccepptedCookies ||
    !process.env.NEXT_PUBLIC_RUDDERSTACK_WRITE_KEY ||
    !process.env.NEXT_PUBLIC_RUDDERSTACK_DATAPLANE_URL
  )
    return

  const sdk = await getSdk()

  sdk.load(
    process.env.NEXT_PUBLIC_RUDDERSTACK_WRITE_KEY,
    process.env.NEXT_PUBLIC_RUDDERSTACK_DATAPLANE_URL,
  )
  sdk.page()
  sdk.identify({ theme: document.documentElement.className })

  rudder = sdk
}

async function getSdk() {
  return await import('rudder-sdk-js')
}
